import angular from 'angular'

export default [
  '$rootScope',
  'uiStateManagerService',
  '$route',
  uiStateManagerMonitorService,
]
/*
 * When uiStateManagerService was originally created. It was called soon enough to operate within its own context.
 *  Today, with the latest update the callstack seems to have shifted an the event-handlers are not registering before
 *  actions are being performed. As a result, this logic must be moved out of the core uiStateManagerService into
 *  a new service so that it can effect state within uiStateManagerService and move up the callstack to monitor user
 *  events. Versatility is key.
 *
 * This monitor is really a decision matrix trying to understand initial and eventual state of angular events.
 */
function uiStateManagerMonitorService(
  $rootScope,
  uiStateManagerService,
  $route
) {
  this._active = false
  const detectRevisionsRouteInverse = function detectRevisionsRouteInverse() {
    let $current = $route.current
    let $previous = $route.previous
    return (
      $current.$$route.originalPath === '/story/:id/' &&
      angular.isDefined($previous) &&
      $previous.$$route.originalPath === '/story/:id/branch/:branch/'
    )
  }
  const detectRevisionsRoute = function detectRevisionsRoute() {
    let $current = $route.current
    let $previous = $route.previous
    return (
      ($current.$$route.originalPath === '/story/:id/branch/:branch/' &&
        angular.isUndefined($previous)) ||
      ($current.$$route.originalPath === '/story/:id/branch/:branch/' &&
        angular.isDefined($previous) &&
        $previous.$$route.originalPath === '/story/:id/branch/:branch/') ||
      ($current.$$route.originalPath ===
        '/story/:id/branch/:branch/revision/:revision/' &&
        angular.isUndefined($previous)) ||
      ($current.$$route.originalPath ===
        '/story/:id/branch/:branch/revision/:revision/' &&
        angular.isDefined($previous) &&
        $previous.$$route.originalPath ===
          '/story/:id/branch/:branch/revision/:revision/')
    )
  }
  this.register = function registerMonitors() {
    if (this._active) {
      return null
    }
    this._active = true

    // Monitor Data-state in the whole application.
    $rootScope.$on('ELLIPSIS_STORY_LOADED', (sender, action) => {
      uiStateManagerService.triggerStateChange('story-loaded', {
        sender: sender,
        action: action,

        state: 'active',
        stateName: 'ellipsis-story-loaded',
        priority: 100,
        payload: {
          storyId: action,
          eventName: sender.name,
        },
      })
      uiStateManagerService.reset()
    })

    $rootScope.$on('RIGHT_TAB_CHANGE', (sender, action) => {
      let stateName = 'revisions'
      if (detectRevisionsRoute() || action['vertActive'] === 'revisions') {
        uiStateManagerService.triggerStateChange('revisions', {
          sender: sender,
          action: action,

          state: 'active',
          stateName: stateName,
          priority: 100,
          payload: {},
        })
      } else {
        uiStateManagerService.triggerStateChange('default', {
          sender: sender,
          action: action,

          state: 'disabled',
          stateName: stateName,
          priority: 100,
          payload: {},
        })
      }
    })
    $rootScope.$on('$routeChangeSuccess', ($event, $current, $previous) => {
      // Handle coming back home to the story from restoring a revision.
      if (detectRevisionsRouteInverse()) {
        let stateName = 'revisions'
        uiStateManagerService.triggerStateChange(stateName, {
          sender: {},
          action: {
            vertAction: 'toolbox',
          },
          state: 'disabled',
          stateName: stateName,
          priority: 100,
          payload: {
            storyId: $current.params.id,
          },
        })
      }
      // Handle coming directly to the page from a URL paste into the browser bar.
      if (detectRevisionsRoute()) {
        let stateName = 'revisions'
        uiStateManagerService.triggerStateChange(stateName, {
          sender: {},
          action: {
            vertAction: 'revision',
          },
          state: 'active',
          stateName: stateName,
          priority: 100,
          payload: {
            revision: $current.params.revision,
            storyId: $current.params.id,
          },
        })
      } else {
        console.debug('Unhandled state', $current.$$route.originalPath)
      }
    })
  }
  /* A list of events we could listen for, but have yet the need to listen for. */
  // DISPATCH
  // CHANGE_TAB
  // DISPATCH
  // ELLIPSIS_STORY_LOADED
  // ELLIPSIS_STORY_PUBLISHED
  // BEFORE_SAVE
  // UPDATE_CONTENT_ELEMENT
  // FIND_AND_REPLACE
  // TOGGLE_FIND_REPLACE
  // CONTENT_COMMENT
  // CREATE_LINK
  // SAVE_SUCCESS
  // COMPOSE_NAV
  // ELLIPSIS_STORY_LOADED
  // ELLIPSIS_STORY_PUBLISHED
  // CONTENT_COMMENT
  //
  // UI Events
  // CHANGE_TAB
  // RIGHT_TAB_CHANGE
  // TOGGLE_FIND_REPLACE
}
